import {Action} from "@ngrx/store";

export type DisplayMode = 'undefined' | 'mobile' | 'tablet_vertical' | 'desktop';
export type ViewMode = 'none' | 'initial' | 'login' | 'main'| 'normal' | 'mobileParam' | 'mobileReports' | 'mobileProfile';

export type HeaderMode = 'none' | 'login' | 'main' | 'common';
export type SidebarMode = 'disabled' | 'enabled';


export enum ESystemActions {
  SetDisplayMode = '[System parameters] Set Display Mode',

  //Установка режимов работы элементов
  SetViewElementHeaderMode = '[System parameters] Set View Element Header mode',
  SetViewElementSidebarMode = '[System parameters] Set View Element Sidebar mode',

  //Установка глобального режима работы приложения
  SetViewMode =  '[System parameters] Set View Mode',
  SetDisplaySize = '[System parameters] Set Display Size'

}
export class SetDisplayMode implements Action{
  public readonly type = ESystemActions.SetDisplayMode;
  constructor(public payload: DisplayMode){}
}

export class SetViewElementHeaderMode implements Action{
  public readonly type = ESystemActions.SetViewElementHeaderMode;
  constructor(public payload: HeaderMode){}
}
export class SetViewElementSidebarMode implements Action{
  public readonly type = ESystemActions.SetViewElementSidebarMode;
  constructor(public payload: SidebarMode){}
}

export class SetViewMode implements Action{
  public readonly type = ESystemActions.SetViewMode;
  constructor(public payload: ViewMode){}
}

export class SetDisplaySize implements Action{
  public readonly type = ESystemActions.SetDisplaySize;
  constructor(public payload: {width: number, height: number}){}
}
export type SystemActions =
  SetDisplayMode |

  SetViewMode |

  SetViewElementHeaderMode |
  SetViewElementSidebarMode |
  SetDisplaySize;

